export const STATIC_HOMEPAGE_URL = 'https://mysoundwise.com';
export const APP_HOMEPAGE_URL = 'https://app.mysoundwise.com';
